const STORAGE_KEY = 'planforvaltning.recentPlans';
const MAX_RECENT = 8;

/** Nylig åpnede planer (napId-er), nyeste først. Lagres i localStorage. */
export function getRecentPlanIds(): string[] {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed: unknown = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
    } catch {
        return [];
    }
}

/** Marker en plan som nylig åpnet (flyttes fremst, deduplisert, kappet til MAX_RECENT). */
export function rememberRecentPlan(napId: string): void {
    if (!napId) return;
    try {
        const next = [napId, ...getRecentPlanIds().filter(id => id !== napId)].slice(0, MAX_RECENT);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
        /* localStorage utilgjengelig — ignorer, «nylig» er ikke kritisk. */
    }
}
